<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import formEmitirReceita from '@/src/components/form-emitir-receita'
import receitaService from '@/src/services/receita'
import relReceita from '@src/components/rel-receita.vue'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'
import empresaService from '@/src/services/empresa_sistema'
import estoqueService from '@/src/services/api-receituario/estoque'

import moment from 'moment'
import * as Sentry from '@sentry/vue'
import produtorRural from '@/src/services/produtor-rural'
import agronomoService from '@/src/services/agronomo'
moment.locale('pt-br')

/**
 * Produtor rural Component
 */
export default {
  directives: { mask },
  components: {
    Layout,
    Loading,
    formEmitirReceita,
    DatePicker,
    relReceita,
  },
  data() {
    return {
      showModalEditarNumeracao: false,
      showFilterSidebar: false,
      novo_numero_receita: '',
      nova_nf: '',
      nova_serie_nf: '',
      novo_valor_nf: '',
      empresa: {},
      receita: { id: null },
      receitas: [],
      receitasExcel: [],
      mostraForm: true,
      relatorioReceita: {},
      relatorioReceitaDownload: null,
      idReceita: null,
      filterAgronomo: '',
      filterProdutor: '',
      filterDataInicial: '',
      filterDataFinal: '',

      produtores: [],
      produtoresTorgeManual: [],
      isLoadingProdutores: false,
      isLoadingProdutoresTorgeManual: false,
      produtoresTotalDisponivel: 0,
      produtorSearchDebounce: null,
      produtorManualTorgeSearchDebounce: null,
      produtorAutocompleteTerm: '',
      produtorManualTorgeAutocompleteTerm: '',
      showProdutorManualTorgeAutocomplete: false,
      agronomos: [],
      produtorSelecionado: {},
      agronomoSelecionado: {},
      columns: [
        {
          label: 'Receita',
          field: 'numero',
        },
        {
          label: 'Responsável',
          field: 'responsavel',
        },
        {
          label: 'Produtor',
          field: 'produtor',
        },
        {
          label: 'Emissão',
          field: 'data',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
      receitaFields: [
        {
          key: 'numero',
          label: 'Número Receita',
        },
        {
          key: 'nf',
          label: 'NF',
        },
        {
          key: 'agronomo.nome',
          label: 'Responsável Técnico',
        },
        {
          key: 'produtor.nome',
          label: 'Produtor',
        },
        {
          key: 'data',
          label: 'Emissão',
        },
        {
          key: 'status',
          label: 'Status',
        },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          status: 'INICIADA',
          descricao: 'Iniciada',
        },
        {
          status: 'EMITIDA',
          descricao: 'Emitida',
        },
        {
          status: 'CANCELADA',
          descricao: 'Cancelada',
        },
      ],
      filter: {
        numero_receita: '',
        data_inicial: '',
        data_final: '',
        status: '',
        cpfcnpj_produtor: ''
      },
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 40, 60, 100],
      showModal: false,
      isLoading: false,
      rows: 0,
      showModalReiniciar: false,
      syncingReceitaId: null,
      isIntegrationLoading: false,
      integrationLoadingMessage: '',
      showModalTorgeProdutos: false,
      showModalTorgeManual: false,
      receitaTorgeSelecionada: null,
      produtosTorgePorItem: [],
      produtosTorgeAdicionais: [],
      itensTorgeManual: [],
      produtorManualTorgeSelecionado: null,
      isLoadingTorgeProdutos: false,
      isDownloadingPdfsLote: false,
      cancelDownloadingPdfsLote: false,
      pdfsLoteAtual: 0,
      pdfsLoteTotal: 0,
    }
  },
  computed: {
    currentLogin() {
      return this.$store.state.auth.currentUser.user || ''
    },
    canDownloadPdfsLote() {
      return true
    },
    shouldForceLocalSignaturePdf() {
      return this.currentLogin === 'prado_defensivo'
    },
    pdfsLoteButtonText() {
      if (!this.isDownloadingPdfsLote) {
        return 'Download PDF em lote'
      }

      if (!this.pdfsLoteTotal) {
        return 'Cancelar'
      }

      return `Cancelar ${this.pdfsLoteAtual}/${this.pdfsLoteTotal}`
    },
    canSyncTorgeFaturamento() {
      return this.currentLogin === 'peufalcao'
    },
    itensTabelaFaturamentoTorge() {
      return [...this.produtosTorgePorItem, ...this.produtosTorgeAdicionais]
    },
    receitaOptionsTorgeManual() {
      return this.receitas.map((receita) => ({
        ...receita,
        torgeLabel: this.getReceitaTorgeManualLabel(receita),
      }))
    },
    produtorAutocompleteOptions() {
      return this.produtores.map((item) => this.getProdutorOptionLabel(item))
    },
  },
  watch: {
    currentPage() {
      this.verifyAndApplyFilters();
    },
    perPage() {
      this.verifyAndApplyFilters();
    },
    '$route.query': {
      handler() {
        if (this.shouldOpenCadastroFromRoute()) {
          this.openCadastroFromRoute()
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.handleConsultarProdutores()
    this.handleConsultarAgronomo()

    this.$root.$on('back', () => {
      this.mostraForm = false
      this.cadastro()
    })
    this.getEmpresa()

    if (this.shouldOpenCadastroFromRoute()) {
      this.openCadastroFromRoute()
      return
    }

    if (this.$store.state.auth.currentUser.user === 'cassul') {
      this.filter.status = 'EMITIDA'
      this.listandoByFilter()
      return
    }

    this.listando()
  },
  methods: {
    shouldOpenCadastroFromRoute() {
      return (
        this.$route &&
        this.$route.query &&
        (this.$route.query.acao === 'novo' ||
          this.$route.query.origem === 'visita-campo')
      )
    },
    openCadastroFromRoute() {
      this.receita = { id: null }
      this.mostraForm = false
    },
    getEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
      })
    },
    formatDate(date) {
      if (date != undefined) return moment.utc(date).format('DD/MM/YYYY')

      return '-'
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .listar(token, this.perPage, this.currentPage)
        .then((resposta) => {
          // Sentry.captureMessage(`timezone do sistema: ${tz}`);
          // Sentry.captureMessage(resposta.data.data);
          this.receitas = resposta.data.data
          this.rows = resposta.data.count

          this.receitasExcel = this.receitas.map(function (element) {
            return {
              numero: element.numero,
              responsavel: element.agronomo.nome,
              produtor: element.produtor.nome,
              data: element.data,
              status: element.status,
            }
          })

          this.isLoading = this.loading(this.show)
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    listandoByFilter() {
      console.log(this.filter)
      if (
        this.filter.numero_receita != undefined ||
        this.filter.status != undefined ||
        this.filter.data_inicial != undefined ||
        this.filter.data_final != undefined ||
        this.produtorSelecionado !== undefined ||
        this.agronomoSelecionado !== undefined ||
        this.filter.cpfcnpj_produtor !== undefined
      ) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = this.loading(this.show)


        let idProdutorRural = this.produtorSelecionado && this.produtorSelecionado.item ? this.produtorSelecionado.item.id_produtor_rural : undefined;
        let idAgronomo = this.agronomoSelecionado && this.agronomoSelecionado.item ? this.agronomoSelecionado.item.id_agronomo : undefined;

        receitaService
          .listarByFilter(
            token,
            this.filter.numero_receita,
            this.filter.status,
            this.filter.data_inicial,
            this.filter.data_final,
            idProdutorRural,
            idAgronomo,
            this.filter.cpfcnpj_produtor,
            this.perPage,
            this.currentPage
          )
          .then((resposta) => {
            this.receitas = resposta.data.data
            this.rows = resposta.data.count
            this.isLoading = this.loading(this.show)
          })
          .catch((error) => {
            this.$bvToast.toast(
              error.response ? error.response.data.message : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.receitas = []
            this.rows = 1
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
    verifyAndApplyFilters() {
      if (this.filter.numero_receita ||
        this.filter.status ||
        this.filter.data_inicial ||
        this.filter.data_final ||
        (this.produtorSelecionado && this.produtorSelecionado.item) ||
        (this.agronomoSelecionado && this.agronomoSelecionado.item) ||
        this.filter.cpfcnpj_produtor ||
        (this.$store.state.auth.currentUser.user === 'cassul' && this.filter.status !== 'EMITIDA')) {
        this.listandoByFilter();
      } else {
        this.listando();
      }
    },
    getFiltrosReceitas() {
      const idProdutorRural = this.produtorSelecionado && this.produtorSelecionado.item
        ? this.produtorSelecionado.item.id_produtor_rural
        : undefined
      const idAgronomo = this.agronomoSelecionado && this.agronomoSelecionado.item
        ? this.agronomoSelecionado.item.id_agronomo
        : undefined

      return {
        numero_receita: this.filter.numero_receita || '',
        status: 'EMITIDA',
        data_inicial: this.filter.data_inicial || '',
        data_final: this.filter.data_final || '',
        id_produtor_rural: idProdutorRural,
        id_agronomo: idAgronomo,
        cpfcnpj_produtor: this.filter.cpfcnpj_produtor
          ? this.filter.cpfcnpj_produtor.replace(/\D/g, '')
          : '',
      }
    },
    aguardarDownloadLote(ms = 1200) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },
    getReceitasFromResponse(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}

      if (Array.isArray(payload.data)) {
        return payload.data
      }

      if (Array.isArray(payload.receitas)) {
        return payload.receitas
      }

      if (Array.isArray(payload)) {
        return payload
      }

      return []
    },
    getTotalReceitasFromResponse(resposta, fallback = 0) {
      const payload = resposta && resposta.data ? resposta.data : {}
      const total = payload.count || payload.total || payload.totalRegistros

      return total !== undefined && total !== null ? Number(total) : fallback
    },
    normalizeAssinaturaImagem(assinatura) {
      if (!assinatura || typeof assinatura !== 'string') {
        return ''
      }

      const assinaturaNormalizada = assinatura.trim()

      if (!assinaturaNormalizada) {
        return ''
      }

      if (/^data:image\/(png|jpe?g|gif|webp);base64,/i.test(assinaturaNormalizada)) {
        return assinaturaNormalizada
      }

      const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
      if (assinaturaNormalizada.length > 24 && base64Regex.test(assinaturaNormalizada)) {
        return `data:image/png;base64,${assinaturaNormalizada}`
      }

      return assinaturaNormalizada
    },
    getAssinaturaTecnico(...fontes) {
      const candidatos = []

      fontes.filter(Boolean).forEach((fonte) => {
        candidatos.push(
          fonte.assinatura,
          fonte.digital_signature,
          fonte.digitalSignature,
          fonte.assinatura_digital,
          fonte.assinaturaDigital
        )

        ;[
          fonte.agronomo,
          fonte.responsavel,
          fonte.tecnico,
          fonte.receita && fonte.receita.agronomo,
          fonte.receita && fonte.receita.responsavel,
          fonte.receita && fonte.receita.tecnico,
        ]
          .filter(Boolean)
          .forEach((pessoa) => {
            candidatos.push(
              pessoa.digital_signature,
              pessoa.digitalSignature,
              pessoa.assinatura,
              pessoa.assinatura_digital,
              pessoa.assinaturaDigital
            )
          })
      })

      const assinatura = candidatos.find((item) => item)
      return this.normalizeAssinaturaImagem(assinatura)
    },
    async buscarReceitasParaDownloadLote(token, filtros) {
      const take = 100
      let page = 1
      let total = 0
      const receitas = []

      do {
        const resposta = await receitaService.listarByFilter(
          token,
          filtros.numero_receita,
          filtros.status,
          filtros.data_inicial,
          filtros.data_final,
          filtros.id_produtor_rural,
          filtros.id_agronomo,
          filtros.cpfcnpj_produtor,
          take,
          page
        )
        const itens = this.getReceitasFromResponse(resposta)

        if (!itens.length) {
          break
        }

        receitas.push(...itens)
        total = this.getTotalReceitasFromResponse(resposta, receitas.length)
        page += 1
      } while (receitas.length < total)

      return receitas.filter((receita) => receita.status === 'EMITIDA')
    },
    async baixarPdfsLotePrado() {
      if (!this.filter.data_inicial || !this.filter.data_final) {
        this.$bvToast.toast('Informe data inicial e data final para baixar os PDFs em lote.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      const token = this.$store.state.auth.currentUser.token
      const filtros = this.getFiltrosReceitas()

      this.isDownloadingPdfsLote = true
      this.cancelDownloadingPdfsLote = false
      this.pdfsLoteAtual = 0
      this.pdfsLoteTotal = 0

      try {
        const receitas = await this.buscarReceitasParaDownloadLote(token, filtros)
        this.pdfsLoteTotal = receitas.length

        if (!receitas.length) {
          this.$bvToast.toast('Nenhuma receita emitida encontrada para o período informado.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        for (const receita of receitas) {
          if (this.cancelDownloadingPdfsLote) {
            break
          }

          this.pdfsLoteAtual += 1
          await this.baixarPdfReceita(receita)
          await this.aguardarDownloadLote()
        }

        if (this.cancelDownloadingPdfsLote) {
          this.$bvToast.toast(`Download em lote cancelado em ${this.pdfsLoteAtual}/${this.pdfsLoteTotal}.`, {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        this.$bvToast.toast(`${receitas.length} downloads de PDF foram disparados.`, {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } catch (error) {
        this.$bvToast.toast(
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Não foi possível baixar os PDFs em lote.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.isDownloadingPdfsLote = false
        this.cancelDownloadingPdfsLote = false
        this.pdfsLoteAtual = 0
        this.pdfsLoteTotal = 0
      }
    },
    cancelarDownloadPdfsLote() {
      this.cancelDownloadingPdfsLote = true
    },
    handleClickDownloadPdfsLotePrado() {
      if (this.isDownloadingPdfsLote) {
        this.cancelarDownloadPdfsLote()
        return
      }

      this.baixarPdfsLotePrado()
    },
    normalizeProdutoresResponse(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}
      const pagination = payload.pagination || {}

      this.produtoresTotalDisponivel = Number(
        pagination.total ||
        payload.total ||
        payload.count ||
        0
      )

      if (Array.isArray(payload.data)) {
        return payload.data
      }

      if (Array.isArray(payload.dados)) {
        return payload.dados
      }

      if (Array.isArray(payload.produtores)) {
        return payload.produtores
      }

      if (Array.isArray(payload)) {
        return payload
      }

      return []
    },
    mergeProdutoresUnicos(produtoresAtuais, novosProdutores) {
      const produtoresPorId = new Map()
      const produtores = [
        ...(produtoresAtuais || []),
        ...(novosProdutores || []),
      ]

      produtores.forEach((produtor) => {
        const idProdutor = produtor && produtor.id_produtor_rural
        if (idProdutor) {
          produtoresPorId.set(idProdutor, produtor)
        }
      })

      return Array.from(produtoresPorId.values())
    },
    async carregarProdutoresTorgeManual(search = '') {
      const token = this.$store.state.auth.currentUser.token
      const termo = search ? String(search).trim() : ''

      this.isLoadingProdutoresTorgeManual = true

      try {
        const resposta = termo
          ? await produtorRural.listarByFilter(token, termo, 1, 20)
          : await produtorRural.listar(token, 1, 20)

        const produtores = this.normalizeProdutoresResponse(resposta)
        this.produtoresTorgeManual = this.mergeProdutoresUnicos(
          this.produtorManualTorgeSelecionado
            ? [this.produtorManualTorgeSelecionado]
            : [],
          produtores
        )
      } catch (error) {
        this.produtoresTorgeManual = this.produtorManualTorgeSelecionado
          ? [this.produtorManualTorgeSelecionado]
          : []
      } finally {
        this.isLoadingProdutoresTorgeManual = false
      }
    },
    handleBuscarProdutoresTorgeManual(search) {
      const termo = search ? String(search).trim() : ''

      if (this.produtorManualTorgeSearchDebounce) {
        clearTimeout(this.produtorManualTorgeSearchDebounce)
      }

      this.produtorManualTorgeSearchDebounce = setTimeout(() => {
        this.carregarProdutoresTorgeManual(termo)
      }, 250)
    },
    handleBuscarProdutores(search, loading) {
      const termo = search ? String(search).trim() : ''

      if (this.produtorSearchDebounce) {
        clearTimeout(this.produtorSearchDebounce)
      }

      this.produtorSearchDebounce = setTimeout(() => {
        this.handleConsultarProdutores(termo, loading)
      }, 250)
    },
    getProdutorOptionLabel(item) {
      if (!item) {
        return ''
      }

      return item.endereco
        ? `${item.nome} - Endereço: ${item.endereco}`
        : item.nome || ''
    },
    syncProdutorSelecionadoFromTerm() {
      const termo = this.produtorAutocompleteTerm
        ? String(this.produtorAutocompleteTerm).trim()
        : ''

      if (!termo) {
        this.produtorSelecionado = {}
        return
      }

      const itemEncontrado = this.produtores.find(
        (item) => this.getProdutorOptionLabel(item) === termo
      )

      this.produtorSelecionado = itemEncontrado ? { item: itemEncontrado } : {}
    },
    handleProdutorAutocompleteInput() {
      this.syncProdutorSelecionadoFromTerm()
      if (!this.produtorAutocompleteTerm) {
        this.produtorSelecionado = {}
      }

      this.handleBuscarProdutores(this.produtorAutocompleteTerm)
    },
    handleProdutorAutocompleteFocus() {
      this.handleConsultarProdutores(this.produtorAutocompleteTerm)
    },
    handleSelecionarProdutor(item) {
      this.produtorSelecionado = { item }
      this.produtorAutocompleteTerm = this.getProdutorOptionLabel(item)
    },
    syncProdutorManualTorgeSelecionadoFromTerm() {
      const termo = this.produtorManualTorgeAutocompleteTerm
        ? String(this.produtorManualTorgeAutocompleteTerm).trim()
        : ''

      if (!termo) {
        this.produtorManualTorgeSelecionado = null
        return
      }

      const itemEncontrado = this.produtoresTorgeManual.find(
        (item) => this.getProdutorOptionLabel(item) === termo
      )

      if (itemEncontrado) {
        this.produtorManualTorgeSelecionado = itemEncontrado
      }
    },
    handleProdutorManualTorgeAutocompleteInput() {
      this.syncProdutorManualTorgeSelecionadoFromTerm()

      const termo = this.produtorManualTorgeAutocompleteTerm
        ? String(this.produtorManualTorgeAutocompleteTerm).trim()
        : ''

      this.showProdutorManualTorgeAutocomplete = termo.length > 0

      if (!termo) {
        this.produtorManualTorgeSelecionado = null
      }

      this.handleBuscarProdutoresTorgeManual(termo)
    },
    handleProdutorManualTorgeAutocompleteFocus() {
      const termo = this.produtorManualTorgeAutocompleteTerm
        ? String(this.produtorManualTorgeAutocompleteTerm).trim()
        : ''

      this.showProdutorManualTorgeAutocomplete = true
      this.carregarProdutoresTorgeManual(termo)
    },
    handleProdutorManualTorgeAutocompleteBlur() {
      setTimeout(() => {
        this.showProdutorManualTorgeAutocomplete = false
      }, 180)
    },
    handleSelecionarProdutorManualTorge(item) {
      this.produtorManualTorgeSelecionado = item
      this.produtorManualTorgeAutocompleteTerm = this.getProdutorOptionLabel(item)
      this.showProdutorManualTorgeAutocomplete = false
    },
    handleConsultarProdutores(search = '', loading = null) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoadingProdutores = true
      if (typeof loading === 'function') {
        loading(true)
      }

      const request = search
        ? produtorRural.listarByFilter(token, search, 1, 20)
        : produtorRural.listar(token, 1, 20)

      request
        .then((resposta) => {
          const items = this.normalizeProdutoresResponse(resposta)

          if (
            this.produtorSelecionado &&
            this.produtorSelecionado.item &&
            this.produtorSelecionado.item.id_produtor_rural &&
            !items.some(
              (item) =>
                item.id_produtor_rural ===
                this.produtorSelecionado.item.id_produtor_rural
            )
          ) {
            this.produtores = [this.produtorSelecionado.item, ...items]
            return
          }

          this.produtores = items
        })
        .catch(() => {
          this.produtores = []
          this.produtoresTotalDisponivel = 0
        })
        .finally(() => {
          this.isLoadingProdutores = false
          if (typeof loading === 'function') {
            loading(false)
          }
        })
    },
    handleConsultarAgronomo() {
      const token = this.$store.state.auth.currentUser.token
      agronomoService
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
        })
    },
    cadastro() {
      this.receita = { id: null }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listando()
      }
    },
    clearFilters() {
      this.filter = {
        numero_receita: '',
        data_inicial: '',
        data_final: '',
        status: '',
        cpfcnpj_produtor: '',
      }
      this.produtorSelecionado = {}
      this.produtorAutocompleteTerm = ''
      this.agronomoSelecionado = {}
      this.currentPage = 1
      if (this.$store.state.auth.currentUser.user === 'cassul') {
        this.filter.status = 'EMITIDA'
      }
      this.verifyAndApplyFilters()
    },
    modalDelete(receita) {
      // if (receita.status !== 'INICIADA') {
      //   this.$bvToast.toast(
      //     'Não é possível cancelar uma RECEITA com status EMITIDA ou CANCELADA',
      //     {
      //       variant: 'danger',
      //       solid: false,
      //       noCloseButton: true,
      //       toaster: 'b-toaster-top-center',
      //     }
      //   )
      //   return
      // }
      this.showModal = true
      this.idReceita = receita.id
    },
    editarNumeracao(receita) {
      this.showModalEditarNumeracao = true
      this.idReceita = receita.id
      this.novo_numero_receita = receita.numero
      this.nova_nf = receita.nf || ''
      this.nova_serie_nf = receita.serie_nf || ''
      this.novo_valor_nf = receita.valor_nf || ''
    },
    reiniciarReceita(receita) {
      this.showModalReiniciar = true
      this.idReceita = receita.id
    },
    handleDelete() {
      // if (this.$store.state.auth.currentUser.user === 'cassul') {
      //   this.$bvToast.toast('Verifique com o administrador do sistema para realizar o cancelamento desse receituário!',
      //     {
      //       variant: 'warning',
      //       solid: false,
      //       noCloseButton: true,
      //       toaster: 'b-toaster-top-center',
      //     }
      //   )
      //   return
      // }
      this.showModal = false
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .deletar(token, this.idReceita)
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvToast.toast('Receita cancelada com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.altaEstoqueReceituario(token, this.idReceita)
          this.listando()
          this.idReceita = 0
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },
    handleEditarNumeracao() {
      this.showModalEditarNumeracao = false
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .editarNumeracao(token, this.idReceita, {
          numero: this.novo_numero_receita,
          nf: this.nova_nf,
          serie_nf: this.nova_serie_nf,
          valor_nf: this.novo_valor_nf,
        })
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvToast.toast('Numeração editada com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listando()
          this.idReceita = 0
          this.novo_numero_receita = ''
          this.nova_nf = ''
          this.nova_serie_nf = ''
          this.novo_valor_nf = ''
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },
    handleReceiniciarReceita() {
      this.showModalReiniciar = false
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .rebuild(token, this.idReceita)
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvToast.toast('Receita reiniciada com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listando()
          this.idReceita = 0
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },

    async altaEstoqueReceituario(token, id) {
      var config = JSON.parse(window.localStorage.getItem('configuracao'))
      if (config.baixa_estoque_receituario) {
        await estoqueService.altaEstoqueReceituario(token, id)
      }
    },

    handleConsultarReceita(receita) {
      if (receita.status !== 'EMITIDA') {
        this.$bvToast.toast(
          'Não é possível visualizar ou imprimir uma RECEITA que não foi EMITIDA',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .consultarReceita(token, receita.id)
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvModal.show('rel-receita')
          this.relatorioReceita = resposta.data
          this.relatorioReceita.assinatura = this.getAssinaturaTecnico(
            receita,
            resposta.data
          )
          this.relatorioReceita.is_sign_produtor =
            receita.agronomo && receita.agronomo.is_sign_prod
          this.relatorioReceita.hash = receita.hash
          this.relatorioReceita.data_hora = receita.data_hora
          this.relatorioReceita.url_pdf = receita.url_pdf
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },
    async baixarPdfReceita(receita) {
      if (receita.status !== 'EMITIDA') {
        this.$bvToast.toast(
          'Não é possível baixar o PDF de uma RECEITA que não foi EMITIDA',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      const token = this.$store.state.auth.currentUser.token
      const idReceita = receita.id_receita || receita.id
      let urlPdf = receita.url_pdf
      const forceLocalSignaturePdf = this.shouldForceLocalSignaturePdf

      let receitaDetalhada = null

      if ((!urlPdf || forceLocalSignaturePdf) && idReceita) {
        this.isLoading = this.loading(this.show)

        try {
          const resposta = await receitaService.consultarReceita(token, idReceita)
          receitaDetalhada = resposta && resposta.data ? resposta.data : {}
          const dadosReceita = receitaDetalhada.receita || receitaDetalhada
          if (!forceLocalSignaturePdf) {
            urlPdf =
              dadosReceita.url_pdf ||
              (receitaDetalhada.receita && receitaDetalhada.receita.url_pdf)
          }
        } catch (error) {
          this.$bvToast.toast('Não foi possível consultar o PDF da receita.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        } finally {
          this.isLoading = this.loading(this.show)
        }
      }

      if (!urlPdf || forceLocalSignaturePdf) {
        const dadosReceita =
          receitaDetalhada && receitaDetalhada.receita
            ? receitaDetalhada.receita
            : receitaDetalhada

        if (!dadosReceita) {
          this.$bvToast.toast('Não foi possível carregar a receita para gerar o PDF.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        this.relatorioReceitaDownload = {
          ...dadosReceita,
          assinatura: this.getAssinaturaTecnico(receita, dadosReceita, receitaDetalhada),
          is_sign_produtor:
            receita.agronomo && receita.agronomo.is_sign_prod,
          hash: receita.hash,
          data_hora: receita.data_hora,
          url_pdf: '',
        }
        this.relatorioReceitaDownload.is_sign_produtor =
          receita.agronomo && receita.agronomo.is_sign_prod

        await new Promise((resolve) => {
          this.$nextTick(() => {
            setTimeout(async () => {
              try {
                if (
                  this.$refs.relReceitaDownloadPdf &&
                  this.$refs.relReceitaDownloadPdf.generateReport
                ) {
                  await this.$refs.relReceitaDownloadPdf.generateReport()
                }
              } finally {
                this.relatorioReceitaDownload = null
                resolve()
              }
            }, 400)
          })
        })
        return
      }

      const link = document.createElement('a')
      link.href = urlPdf
      link.target = '_blank'
      link.rel = 'noopener'
      link.download = `receita-${receita.numero || idReceita || 'emitida'}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    editReceita(receita) {
      if (receita.status !== 'INICIADA') {
        this.$bvToast.toast(
          'Não é possível editar uma RECEITA com status EMITIDA ou CANCELADA',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }
      this.receita = receita
      this.mostraForm = false
    },
    printReceita() {
      this.$root.$emit('print-receita')
    },
    normalizeItensReceitaParaTorge(receitaDetalhada) {
      const itens = receitaDetalhada && Array.isArray(receitaDetalhada.itens)
        ? receitaDetalhada.itens
        : []

      return itens
        .map((item, index) => {
          const nomeProdutoReceita = item && item.nomeProduto
            ? String(item.nomeProduto).trim()
            : item && item.produto && item.produto.nome
              ? String(item.produto.nome).trim()
              : ''

          const idItemReceita = this.getItemReceitaId(item)

          if (!nomeProdutoReceita) {
            return null
          }

          return {
            index,
            idItemReceita,
            tipoItemTorge: 'receituario',
            nomeProdutoReceita,
            quantidade: '',
            itemReceita: item,
            termoBuscaTorge: '',
            opcoesTorge: [],
            produtoTorgeSelecionado: null,
            isBuscando: false,
          }
        })
        .filter(Boolean)
    },
    getItemReceitaId(item) {
      if (!item) {
        return null
      }

      return item.id_item_receita ||
        item.idItemReceita ||
        item.id_item ||
        item.idItem ||
        item.itemReceitaId ||
        item.item_receita_id ||
        item.id ||
        null
    },
    getCodigoTorgeProduto(produto) {
      if (!produto) {
        return null
      }

      return produto.codigoTorge ||
        produto.codigo_torge ||
        produto.codigo ||
        produto.idProduto ||
        produto.id_produto ||
        produto.id ||
        produto.sku ||
        null
    },
    parseQuantidadeTorge(valor) {
      if (valor === undefined || valor === null) {
        return null
      }

      const valorNormalizado = String(valor)
        .trim()
        .replace(/\s+/g, '')
        .replace(',', '.')

      if (!valorNormalizado) {
        return null
      }

      const quantidade = Number(valorNormalizado)
      return Number.isFinite(quantidade) ? quantidade : null
    },
    normalizeProdutosTorgeResponse(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}

      if (Array.isArray(payload)) {
        return payload
      }

      if (Array.isArray(payload.data)) {
        return payload.data
      }

      if (Array.isArray(payload.dados)) {
        return payload.dados
      }

      if (Array.isArray(payload.produtos)) {
        return payload.produtos
      }

      if (Array.isArray(payload.items)) {
        return payload.items
      }

      if (Array.isArray(payload.registros)) {
        return payload.registros
      }

      return []
    },
    getProdutoTorgeLabel(produto) {
      if (!produto) {
        return ''
      }

      const nome = produto.nome || produto.nomeProduto || produto.descricao || produto.description || ''
      const embalagem = produto.embalagem || produto.nomeEmbalagem || produto.unidade || produto.un || produto.volume || produto.dosagem || ''
      const codigo = produto.codigo || produto.id || produto.idProduto || produto.sku || ''
      const disponivel = produto.disponivel !== undefined && produto.disponivel !== null
        ? `Disponivel: ${produto.disponivel}`
        : ''

      return [nome, embalagem ? `Unidade: ${embalagem}` : '', codigo ? `Cod: ${codigo}` : '', disponivel]
        .filter(Boolean)
        .join(' | ')
    },
    getTermoBuscaProdutoTorge(nomeProdutoReceita) {
      const nomeNormalizado = nomeProdutoReceita
        ? String(nomeProdutoReceita).trim()
        : ''

      if (!nomeNormalizado) {
        return ''
      }

      const partesNome = nomeNormalizado.split(/\s+/).filter(Boolean)
      return partesNome.length > 1 ? partesNome[0] : nomeNormalizado
    },
    getReceitaTorgeManualLabel(receita) {
      if (!receita) {
        return ''
      }

      const numero = receita.numero || receita.numero_receita || 'Sem numero'
      const produtor = receita && receita.produtor && receita.produtor.nome
        ? receita.produtor.nome
        : 'Sem produtor'

      return `Receita ${numero} - ${produtor}`
    },
    criarProdutoTorgeAdicional() {
      return {
        id: `extra-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        tipoItemTorge: 'adicional',
        nomeProdutoReceita: '',
        quantidade: '',
        termoBuscaTorge: '',
        opcoesTorge: [],
        produtoTorgeSelecionado: null,
        isBuscando: false,
      }
    },
    criarItemTorgeManual() {
      return {
        id: `manual-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        receitaSelecionada: null,
        quantidade: '',
        opcoesTorge: [],
        produtoTorgeSelecionado: null,
        isBuscando: false,
      }
    },
    async carregarOpcoesTorgePorTermo(termoBuscaTorge) {
      const token = this.$store.state.auth.currentUser.token
      const respostaProdutos = await receitaService.buscarProdutosTorge(token, {
        filtro: termoBuscaTorge,
      })

      return this.normalizeProdutosTorgeResponse(respostaProdutos)
    },
    async adicionarProdutoTorgeAdicional() {
      const itemAdicional = this.criarProdutoTorgeAdicional()
      itemAdicional.isBuscando = true
      this.produtosTorgeAdicionais.push(itemAdicional)

      try {
        const opcoesTorge = await this.carregarOpcoesTorgePorTermo('')
        itemAdicional.opcoesTorge = opcoesTorge
      } finally {
        itemAdicional.isBuscando = false
      }
    },
    async adicionarItemTorgeManual() {
      const itemManual = this.criarItemTorgeManual()
      itemManual.isBuscando = true
      this.itensTorgeManual.push(itemManual)

      try {
        const opcoesTorge = await this.carregarOpcoesTorgePorTermo('')
        itemManual.opcoesTorge = opcoesTorge
      } finally {
        itemManual.isBuscando = false
      }
    },
    removerProdutoTorgeAdicional(index) {
      this.produtosTorgeAdicionais.splice(index, 1)
    },
    removerItemTorgeManual(index) {
      this.itensTorgeManual.splice(index, 1)
    },
    removerItemTabelaFaturamento(item) {
      if (!item || item.tipoItemTorge !== 'adicional') {
        return
      }

      const index = this.produtosTorgeAdicionais.findIndex((itemAdicional) => itemAdicional.id === item.id)
      if (index >= 0) {
        this.removerProdutoTorgeAdicional(index)
      }
    },
    async buscarProdutoTorgeItem(itemAdicional) {
      const termoBuscaTorge = this.getTermoBuscaProdutoTorge(
        itemAdicional.termoBuscaTorge || itemAdicional.nomeProdutoReceita
      )

      if (!termoBuscaTorge) {
        this.$bvToast.toast('Informe o nome do produto para realizar a busca.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      itemAdicional.isBuscando = true

      try {
        const opcoesTorge = await this.carregarOpcoesTorgePorTermo(termoBuscaTorge)

        itemAdicional.nomeProdutoReceita = itemAdicional.nomeProdutoReceita || termoBuscaTorge
        itemAdicional.termoBuscaTorge = termoBuscaTorge
        itemAdicional.opcoesTorge = opcoesTorge
        itemAdicional.produtoTorgeSelecionado = opcoesTorge.length === 1 ? opcoesTorge[0] : null

        if (!opcoesTorge.length) {
          this.$bvToast.toast('Nenhum produto da Torge foi encontrado para esta busca.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        }
      } finally {
        itemAdicional.isBuscando = false
      }
    },
    getItensFaturamentoTorge() {
      return this.itensTabelaFaturamentoTorge
    },
    buildPayloadFaturamentoTorge() {
      return {
        itens: this.getItensFaturamentoTorge().map((item, index) => {
          return {
            item: index + 1,
            codigoTorge: this.getCodigoTorgeProduto(item.produtoTorgeSelecionado),
            quantidadeFaturamento: this.parseQuantidadeTorge(item.quantidade),
          }
        }),
      }
    },
    buildPayloadFaturamentoManualTorge() {
      return {
        idProdutorRural: this.produtorManualTorgeSelecionado
          ? this.produtorManualTorgeSelecionado.id_produtor_rural
          : null,
        itens: this.itensTorgeManual.map((item, index) => {
          const receitaSelecionada = item.receitaSelecionada || {}

          return {
            item: index + 1,
            idReceita: receitaSelecionada.id_receita || receitaSelecionada.id || null,
            numeroReceita: receitaSelecionada.numero || receitaSelecionada.numero_receita || null,
            codigoTorge: this.getCodigoTorgeProduto(item.produtoTorgeSelecionado),
            quantidadeFaturamento: this.parseQuantidadeTorge(item.quantidade),
          }
        }),
      }
    },
    async abrirSelecaoProdutosTorge(receita) {
      const token = this.$store.state.auth.currentUser.token
      const idReceita = receita.id_receita || receita.id
      this.receitaTorgeSelecionada = receita
      this.produtosTorgePorItem = []
      this.isLoadingTorgeProdutos = true
      this.showModalTorgeProdutos = true

      const response = await receitaService.consultarItemReceita(token, idReceita)
      const itens = this.normalizeItensReceitaParaTorge(response && response.data ? response.data : {})

      const itensComOpcoes = await Promise.all(
        itens.map(async (item) => {
          const termoBuscaTorge = this.getTermoBuscaProdutoTorge(item.nomeProdutoReceita)
          const opcoesTorge = await this.carregarOpcoesTorgePorTermo(termoBuscaTorge)

          return {
            ...item,
            termoBuscaTorge,
            opcoesTorge,
            produtoTorgeSelecionado: opcoesTorge.length === 1 ? opcoesTorge[0] : null,
          }
        })
      )

      this.produtosTorgePorItem = itensComOpcoes
      this.produtosTorgeAdicionais = []
      this.isLoadingTorgeProdutos = false
    },
    async abrirFaturamentoManualTorge() {
      this.itensTorgeManual = []
      this.produtorManualTorgeSelecionado = null
      this.produtorManualTorgeAutocompleteTerm = ''
      this.produtoresTorgeManual = []
      this.showProdutorManualTorgeAutocomplete = false
      this.showModalTorgeManual = true
      await this.adicionarItemTorgeManual()
    },
    async confirmarEnvioFaturamentoTorge() {
      const token = this.$store.state.auth.currentUser.token
      const receita = this.receitaTorgeSelecionada
      const idReceita = receita && (receita.id_receita || receita.id)

      if (!idReceita) {
        return
      }

      const itensFaturamento = this.getItensFaturamentoTorge()
      if (!itensFaturamento.length) {
        this.$bvToast.toast(
          'Adicione ao menos um produto para enviar ao faturamento.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      const itensSemSelecao = itensFaturamento.filter(
        (item) => !item.produtoTorgeSelecionado
      )
      const itensSemQuantidade = itensFaturamento.filter(
        (item) => this.parseQuantidadeTorge(item.quantidade) === null || this.parseQuantidadeTorge(item.quantidade) <= 0
      )

      if (itensSemSelecao.length > 0) {
        this.$bvToast.toast(
          'Selecione o produto/unidade da Torge para todos os itens antes de continuar.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      if (itensSemQuantidade.length > 0) {
        this.$bvToast.toast(
          'Informe uma quantidade valida para todos os itens antes de continuar.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      this.showModalTorgeProdutos = false
      this.syncingReceitaId = idReceita
      this.isIntegrationLoading = true
      this.integrationLoadingMessage = 'Estamos processando os dados e enviando a receita para a integracao da Torge. Aguarde...'

      try {
        const resposta = await receitaService.enviarFaturamentoTorge(
          token,
          idReceita,
          this.buildPayloadFaturamentoTorge()
        )

        this.$bvToast.toast(
          resposta.data.message || resposta.data.mensagem || 'Receita enviada para faturamento da Torge com sucesso.',
          {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } catch (error) {
        this.$bvToast.toast(
          error.response && error.response.data
            ? error.response.data.message || error.response.data.mensagem
            : 'Não foi possível enviar a receita para faturamento da Torge.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.syncingReceitaId = null
        this.isIntegrationLoading = false
        this.integrationLoadingMessage = ''
        this.resetModalTorgeProdutos()
      }
    },
    async confirmarEnvioFaturamentoManualTorge() {
      const token = this.$store.state.auth.currentUser.token

      if (!this.produtorManualTorgeSelecionado || !this.produtorManualTorgeSelecionado.id_produtor_rural) {
        this.$bvToast.toast(
          'Selecione o produtor rural antes de continuar.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      if (!this.itensTorgeManual.length) {
        this.$bvToast.toast(
          'Adicione ao menos um item no faturamento manual.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      const itensSemSelecao = this.itensTorgeManual.filter(
        (item) => !item.produtoTorgeSelecionado
      )
      const itensSemQuantidade = this.itensTorgeManual.filter(
        (item) => this.parseQuantidadeTorge(item.quantidade) === null || this.parseQuantidadeTorge(item.quantidade) <= 0
      )

      if (itensSemSelecao.length > 0) {
        this.$bvToast.toast(
          'Selecione o produto/unidade da Torge para todos os itens antes de continuar.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      if (itensSemQuantidade.length > 0) {
        this.$bvToast.toast(
          'Informe uma quantidade valida para todos os itens antes de continuar.',
          {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }

      this.showModalTorgeManual = false
      this.syncingReceitaId = 'manual-torge'
      this.isIntegrationLoading = true
      this.integrationLoadingMessage = 'Estamos processando os dados e enviando o faturamento manual para a integracao da Torge. Aguarde...'

      try {
        const resposta = await receitaService.enviarFaturamentoManualTorge(
          token,
          this.buildPayloadFaturamentoManualTorge()
        )

        this.$bvToast.toast(
          resposta.data.message || resposta.data.mensagem || 'Faturamento manual enviado para a Torge com sucesso.',
          {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } catch (error) {
        this.$bvToast.toast(
          error.response && error.response.data
            ? error.response.data.message || error.response.data.mensagem
            : 'Não foi possível enviar o faturamento manual para a Torge.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.syncingReceitaId = null
        this.isIntegrationLoading = false
        this.integrationLoadingMessage = ''
        this.resetModalTorgeManual()
      }
    },
    resetModalTorgeProdutos() {
      this.showModalTorgeProdutos = false
      this.receitaTorgeSelecionada = null
      this.produtosTorgePorItem = []
      this.produtosTorgeAdicionais = []
      this.isLoadingTorgeProdutos = false
    },
    resetModalTorgeManual() {
      this.showModalTorgeManual = false
      this.itensTorgeManual = []
      this.produtorManualTorgeSelecionado = null
      this.produtorManualTorgeAutocompleteTerm = ''
      this.produtoresTorgeManual = []
      this.showProdutorManualTorgeAutocomplete = false
    },
    async handleEnviarFaturamentoTorge(receita) {
      try {
        await this.abrirSelecaoProdutosTorge(receita)
      } catch (error) {
        this.$bvToast.toast(
          error.response && error.response.data
            ? error.response.data.message || error.response.data.mensagem
            : error.message || 'Não foi possível preparar o faturamento da Torge.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },
    async handleAbrirFaturamentoManualTorge() {
      try {
        await this.abrirFaturamentoManualTorge()
      } catch (error) {
        this.$bvToast.toast(
          error.response && error.response.data
            ? error.response.data.message || error.response.data.mensagem
            : error.message || 'Não foi possível preparar o faturamento manual da Torge.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },
    async handleEnviarWebhookSisdev(receita) {
      const token = this.$store.state.auth.currentUser.token
      const nomeProdutor = receita && receita.produtor && receita.produtor.nome
        ? String(receita.produtor.nome).trim()
        : ''

      if (!nomeProdutor) {
        this.$bvToast.toast('Não foi possível identificar o nome do produtor para consultar as credenciais do SISDEV.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.isLoading = this.loading(this.show)

      try {
        const produtorResponse = await produtorRural.listarByFilter(token, nomeProdutor)
        const produtores = Array.isArray(produtorResponse && produtorResponse.data)
          ? produtorResponse.data
          : Array.isArray(produtorResponse && produtorResponse.data && produtorResponse.data.data)
            ? produtorResponse.data.data
            : Array.isArray(produtorResponse && produtorResponse.data && produtorResponse.data.produtores)
              ? produtorResponse.data.produtores
              : []

        const produtorEncontrado = produtores.find((item) => {
          const nomeAtual = item && item.nome ? String(item.nome).trim().toLowerCase() : ''
          return nomeAtual === nomeProdutor.toLowerCase()
        }) || produtores[0]

        const usuarioSisdev = produtorEncontrado && produtorEncontrado.usuario_sisdev
          ? String(produtorEncontrado.usuario_sisdev).trim()
          : ''
        const senhaSisdev = produtorEncontrado && produtorEncontrado.senha_sisdev
          ? String(produtorEncontrado.senha_sisdev).trim()
          : ''

        if (!usuarioSisdev || !senhaSisdev) {
          this.isLoading = false
          this.$bvToast.toast('O produtor não possui usuário_sisdev e senha_sisdev cadastrados.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        await receitaService.enviarWebhookSisdev({
          idReceita: receita.id,
          usuario_sisdev: usuarioSisdev,
          senha_sisdev: senhaSisdev,
        })

        this.isLoading = this.loading(this.show)
        this.$bvToast.toast(`Receita ${receita.id} enviada para o webhook SISDEV.`, {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } catch (error) {
        this.isLoading = false
        this.$bvToast.toast('Não foi possível enviar a receita para o webhook SISDEV.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="titulo">Receitas</div>
            <div class="subTitulo">Visualize, edite e cadastre novas receitas na plataforma.</div>
          </div>
          <div class="col-md-4">
            <div class="float-md-right receita-header-actions">
              <button v-if="mostraForm" class="btn btn-outline-secondary mr-2" @click="showFilterSidebar = true">
                Filtros
              </button>
              <button class="btn btn-primary" @click="cadastro">
                <span v-if="mostraForm">Nova Receita</span>
                <span v-else>Visualizar Receitas</span>
              </button>
            </div>
          </div>
        </div>
        <div v-if="mostraForm" class="row">
          <div class="col-md-12">
            <div class="borda"></div>
            <div class="row mb-4">
              <div class="col-md-8">
                <div class="description found"><b>Total de Registros: {{ rows }}</b></div>
              </div>
              <div class="col-md-4">
                <div class="float-md-right d-flex align-items-end justify-content-md-end">
                  <button
                    v-if="canSyncTorgeFaturamento"
                    class="btn btn-outline-primary mr-3"
                    @click="handleAbrirFaturamentoManualTorge"
                  >
                    Faturamento
                  </button>
                  <button
                    v-if="canDownloadPdfsLote"
                    :class="[
                      'btn mr-3',
                      isDownloadingPdfsLote ? 'btn-outline-danger' : 'btn-outline-primary',
                    ]"
                    @click="handleClickDownloadPdfsLotePrado"
                  >
                    {{ pdfsLoteButtonText }}
                  </button>
                  
                  <button class="btn btn-primary" @click="$refs.btnexport.$el.click()">
                    Exportar Excel
                    <vue-excel-xlsx ref="btnexport" style="display: none" :data="receitasExcel" :columns="columns"
                      :filename="'receitas'" :sheetname="'receitas'">
                    </vue-excel-xlsx>
                  </button>
                  <div class="ml-3">
                    <b-form-group label="Itens por página" class="mb-0">
                      <b-form-select v-model="perPage" class="numPerPage" :options="pageOptions"></b-form-select>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
            <b-table striped hover responsive borderless bordered outlined small :items="receitas"
              :fields="receitaFields" :per-page="perPage">
              <template v-slot:cell(data)="row">
                {{ formatDate(row.item.data) }}
              </template>
              <template v-slot:cell(status)="row">
                <b-badge v-if="row.item.status === 'EMITIDA'" variant="primary" class="pl-2 pr-2 pt-1 pb-1">{{
                row.item.status }}</b-badge>
                <b-badge v-else-if="row.item.status === 'INICIADA'" variant="info" class="pl-2 pr-2 pt-1 pb-1">{{
                row.item.status }}</b-badge>
                <b-badge v-else variant="danger" class="pl-2 pr-2 pt-1 pb-1">{{
                row.item.status
              }}</b-badge>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="btn-group mb-2">
                  <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="uil uil-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click="editReceita(row.item)">Editar</b-dropdown-item>
                    <b-dropdown-item @click="handleConsultarReceita(row.item)">Visualizar</b-dropdown-item>
                    <b-dropdown-item @click="baixarPdfReceita(row.item)">Download</b-dropdown-item>
                    <b-dropdown-item @click="modalDelete(row.item)">Cancelar</b-dropdown-item>
                    <b-dropdown-item
                      @click="editarNumeracao(row.item)">Editar numeração</b-dropdown-item>
                    <b-dropdown-item @click="reiniciarReceita(row.item)">Reiniciar receituário</b-dropdown-item>
                    <b-dropdown-item
                      v-if="canSyncTorgeFaturamento"
                      :disabled="syncingReceitaId === (row.item.id_receita || row.item.id)"
                      @click="handleEnviarFaturamentoTorge(row.item)"
                    >
                      {{ syncingReceitaId === (row.item.id_receita || row.item.id) ? 'Enviando...' : 'Enviar faturamento Torge' }}
                    </b-dropdown-item>
                    <b-dropdown-item v-show="$store.state.auth.currentUser.user === 'agrotresestrelas' || $store.state.auth.currentUser.user === 'admin_sistema'" @click="handleEnviarWebhookSisdev(row.item)">Enviar webhook SISDEV</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="btn-group mb-4">&#8195;&#8195;</div>
              </template>
            </b-table>

            <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
          </div>
        </div>
        <div v-else>
          <formEmitirReceita :receita="receita" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <div class="receita-download-renderer" aria-hidden="true">
      <relReceita
        v-if="relatorioReceitaDownload"
        ref="relReceitaDownloadPdf"
        :receita="relatorioReceitaDownload"
        :empresa="empresa"
        :is-signature="shouldForceLocalSignaturePdf || empresa.is_digital_signature"
        :force-local-pdf-download="shouldForceLocalSignaturePdf"
        :url-pdf="relatorioReceitaDownload.url_pdf"
      />
    </div>
    <b-modal v-model="showModal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja cancelar a Receita?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="rel-receita" size="lg" :hide-footer="true" @hidden="listando()">
      <relReceita :receita="relatorioReceita" :empresa="empresa" :is-signature="shouldForceLocalSignaturePdf || empresa.is_digital_signature"
        :force-local-pdf-download="shouldForceLocalSignaturePdf"
        :url-pdf="relatorioReceita.url_pdf" />
      <template v-slot:modal-header>
        <div class="ml-auto">
          <b-button class="mr-2" variant="danger" @click="$bvModal.hide('rel-receita')">Sair</b-button>
          <b-button v-if="relatorioReceita.url_pdf && !shouldForceLocalSignaturePdf" :href="relatorioReceita.url_pdf" target="_blank"
            variant="success">Ver Receita</b-button>
          <b-button v-else variant="primary" @click="printReceita">Imprimir</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="showModalEditarNumeracao" title="Editar Numeração" title-class="font-18">
      <div class="col-md-12">
        <b-form-group id="input-group-1" label="Digite o novo número da receita" label-for="input-2">
          <b-form-input v-model="novo_numero_receita" type="text" required></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-nf" label="NF" label-for="input-nf">
          <b-form-input id="input-nf" v-model="nova_nf" type="text"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-serie-nf" label="Série NF" label-for="input-serie-nf">
          <b-form-input id="input-serie-nf" v-model="nova_serie_nf" type="text"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-valor-nf" label="Valor NF" label-for="input-valor-nf">
          <b-form-input id="input-valor-nf" v-model="novo_valor_nf" type="number" step="0.01"></b-form-input>
        </b-form-group>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModalEditarNumeracao = false">Não</b-button>
        <b-button variant="primary" @click="handleEditarNumeracao">Sim</b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModalReiniciar" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja reiniciar a Receita?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModalReiniciar = false">Não</b-button>
        <b-button variant="danger" @click="handleReceiniciarReceita">Sim</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModalTorgeProdutos"
      size="xl"
      dialog-class="torge-products-modal"
      title="Enviar para faturamento"
      title-class="font-18"
      @hidden="resetModalTorgeProdutos"
    >
      <div v-if="isLoadingTorgeProdutos" class="torge-products-loading">
        <b-spinner variant="primary"></b-spinner>
        <p class="torge-products-loading-text">Carregando produtos da Torge...</p>
      </div>

      <div v-else>
        <div class="torge-products-section">
          <div class="torge-products-section-header">
            <div>
              <h6 class="mb-1">Itens do faturamento</h6>
              <small class="text-muted">Os itens do receituário já vêm carregados e você pode adicionar novos produtos na mesma tabela.</small>
            </div>
          </div>

          <div class="torge-table-wrapper">
            <b-table
              small
              bordered
              responsive
              :items="itensTabelaFaturamentoTorge"
              :fields="[
                { key: 'produtoTorge', label: 'Produto/unidade Torge' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'acoes', label: 'Ações' }
              ]"
              class="torge-products-table"
            >
              <template #head(acoes)>
                <div class="torge-table-head-action">
                  <span>Ações</span>
                  <b-button variant="outline-primary" size="sm" @click="adicionarProdutoTorgeAdicional">
                    Adicionar item
                  </b-button>
                </div>
              </template>

              <template #empty>
                <div class="text-muted torge-empty-state">
                  Nenhum item disponível. Adicione um produto para continuar.
                </div>
              </template>

              <template #cell(produtoTorge)="row">
                <v-select
                  class="style-select"
                  :options="row.item.opcoesTorge"
                  :label="'nome'"
                  :reduce="(produto) => produto"
                  v-model="row.item.produtoTorgeSelecionado"
                  :disabled="row.item.isBuscando"
                >
                  <template #option="option">
                    <div>{{ getProdutoTorgeLabel(option) }}</div>
                  </template>
                  <template #selected-option="option">
                    <div>{{ getProdutoTorgeLabel(option) }}</div>
                  </template>
                  <template #no-options>
                    Nenhum produto encontrado na Torge.
                  </template>
                </v-select>
                <small v-if="row.item.isBuscando" class="text-muted">Carregando produtos...</small>
                <small class="text-muted">Campo obrigatório.</small>
              </template>

              <template #cell(quantidade)="row">
                <b-form-input
                  v-model="row.item.quantidade"
                  type="text"
                  placeholder="Informe a quantidade"
                ></b-form-input>
                <small class="text-muted">Campo obrigatório.</small>
              </template>

              <template #cell(acoes)="row">
                <b-button
                  v-if="row.item.tipoItemTorge === 'adicional'"
                  variant="outline-danger"
                  size="sm"
                  @click="removerItemTabelaFaturamento(row.item)"
                >
                  Remover
                </b-button>
                <span v-else class="text-muted">Fixo</span>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="light" @click="resetModalTorgeProdutos">Cancelar</b-button>
        <b-button variant="primary" :disabled="isLoadingTorgeProdutos" @click="confirmarEnvioFaturamentoTorge">
          Confirmar envio
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModalTorgeManual"
      size="xl"
      dialog-class="torge-products-modal"
      title="Faturamento"
      title-class="font-18"
      @hidden="resetModalTorgeManual"
    >
      <div class="torge-products-section">
        <div class="torge-products-section-header">
          <div>
            <h6 class="mb-1">Montagem livre de itens</h6>
            <small class="text-muted">
              Monte os itens como desejar, incluindo produtos de receituarios diferentes e outros produtos sem receituario.
            </small>
          </div>
        </div>

        <b-form-group label="Produtor rural">
          <div class="produtor-autocomplete">
            <b-form-input
              v-model="produtorManualTorgeAutocompleteTerm"
              autocomplete="off"
              placeholder="Digite para buscar produtores"
              @input="handleProdutorManualTorgeAutocompleteInput"
              @change="syncProdutorManualTorgeSelecionadoFromTerm"
              @focus="handleProdutorManualTorgeAutocompleteFocus"
              @blur="handleProdutorManualTorgeAutocompleteBlur"
            />
            <div v-if="showProdutorManualTorgeAutocomplete" class="produtor-autocomplete-menu">
              <div v-if="isLoadingProdutoresTorgeManual" class="produtor-autocomplete-state">
                Buscando produtores...
              </div>
              <button
                v-for="item in produtoresTorgeManual"
                v-else
                :key="item.id_produtor_rural"
                type="button"
                class="produtor-autocomplete-item"
                @mousedown.prevent="handleSelecionarProdutorManualTorge(item)"
              >
                <span class="produtor-autocomplete-name">{{ item.nome }}</span>
                <span v-if="item.endereco" class="produtor-autocomplete-meta">{{ item.endereco }}</span>
              </button>
              <div
                v-if="!isLoadingProdutoresTorgeManual && !produtoresTorgeManual.length"
                class="produtor-autocomplete-state"
              >
                Nenhum produtor encontrado.
              </div>
            </div>
          </div>
        </b-form-group>

        <div class="torge-table-wrapper">
          <b-table
            small
            bordered
            responsive
            :items="itensTorgeManual"
            :fields="[
              { key: 'receita', label: 'Receituario' },
              { key: 'produtoTorge', label: 'Produto/unidade Torge' },
              { key: 'quantidade', label: 'Quantidade' },
              { key: 'acoes', label: 'Ações' }
            ]"
            class="torge-products-table"
          >
            <template #head(acoes)>
              <div class="torge-table-head-action">
                <span>Ações</span>
                <b-button variant="outline-primary" size="sm" @click="adicionarItemTorgeManual">
                  Adicionar item
                </b-button>
              </div>
            </template>

            <template #empty>
              <div class="text-muted torge-empty-state">
                Nenhum item adicionado. Use o botão acima para incluir produtos no faturamento.
              </div>
            </template>

            <template #cell(receita)="row">
              <v-select
                class="style-select"
                :options="receitaOptionsTorgeManual"
                label="torgeLabel"
                :reduce="(receita) => receita"
                v-model="row.item.receitaSelecionada"
              >
                <template #no-options>
                  Nenhuma receita disponivel na listagem atual.
                </template>
              </v-select>
              <small class="text-muted">Opcional para produtos extras.</small>
            </template>

            <template #cell(produtoTorge)="row">
              <v-select
                class="style-select"
                :options="row.item.opcoesTorge"
                :label="'nome'"
                :reduce="(produto) => produto"
                v-model="row.item.produtoTorgeSelecionado"
                :disabled="row.item.isBuscando"
              >
                <template #option="option">
                  <div>{{ getProdutoTorgeLabel(option) }}</div>
                </template>
                <template #selected-option="option">
                  <div>{{ getProdutoTorgeLabel(option) }}</div>
                </template>
                <template #no-options>
                  Nenhum produto encontrado na Torge.
                </template>
              </v-select>
              <small v-if="row.item.isBuscando" class="text-muted">Carregando produtos...</small>
              <small class="text-muted">Campo obrigatório.</small>
            </template>

            <template #cell(quantidade)="row">
              <b-form-input
                v-model="row.item.quantidade"
                type="text"
                placeholder="Informe a quantidade"
              ></b-form-input>
              <small class="text-muted">Campo obrigatório.</small>
            </template>

            <template #cell(acoes)="row">
              <b-button variant="outline-danger" size="sm" @click="removerItemTorgeManual(row.index)">
                Remover
              </b-button>
            </template>
          </b-table>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="light" @click="resetModalTorgeManual">Cancelar</b-button>
        <b-button variant="primary" @click="confirmarEnvioFaturamentoManualTorge">
          Confirmar envio
        </b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap></b-overlay>

    <b-modal
      v-model="isIntegrationLoading"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      body-class="integration-loading-modal-body"
    >
      <div class="integration-loading-content">
        <b-spinner variant="primary"></b-spinner>
        <p class="integration-loading-text">
          {{ integrationLoadingMessage || 'Carregando dados...' }}
        </p>
      </div>
    </b-modal>

    <b-sidebar v-model="showFilterSidebar" right shadow backdrop width="420px" title="Filtros da Receita">
      <div class="filter-sidebar">
        <div class="filter-sidebar-subtitle">
          Defina os filtros da listagem e aplique a pesquisa quando estiver pronto.
        </div>

        <b-form-group id="input-group-1" label="Status" label-for="input-2">
          <v-select v-model="filter.status" class="style-select" label="descricao" :options="status"
            :reduce="(stat) => stat.status" :dense="true"></v-select>
        </b-form-group>

        <b-form-group id="input-group-1" label="Número da receita" label-for="input-2">
          <b-form-input v-model="filter.numero_receita" type="text" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-cpfcnpjprodutor" label="CPF/CNPJ Produtor" label-for="filter">
          <b-form-input v-model="filter.cpfcnpj_produtor" v-mask="['###.###.###-##', '##.###.###/####-##']"
            type="text" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-1" label="Produtores" label-for="filter">
          <b-form-input
            v-model="produtorAutocompleteTerm"
            list="receita-produtores-autocomplete"
            autocomplete="off"
            placeholder="Digite para buscar produtores"
            @input="handleProdutorAutocompleteInput"
            @change="syncProdutorSelecionadoFromTerm"
            @focus="handleProdutorAutocompleteFocus"
          />
          <b-form-datalist
            id="receita-produtores-autocomplete"
            :options="produtorAutocompleteOptions"
          />
        </b-form-group>

        <b-form-group id="input-group-1" label="Agrônomos" label-for="filter">
          <v-select v-model="agronomoSelecionado.item" class="style-select" label="nome" :options="agronomos"
            :reduce="(item) => item" :dense="true"></v-select>
        </b-form-group>

        <b-form-group id="input-group-1" label="Data inicial" label-for="input-2">
          <b-form-datepicker id="datepicker-inicial" v-model="filter.data_inicial"
            placeholder="Selecione a data inicial" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="pt-br">
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>

        <b-form-group id="input-group-1" label="Data final" label-for="input-2">
          <b-form-datepicker id="datepicker-final" v-model="filter.data_final"
            placeholder="Selecione a data final" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="pt-br">
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>

        <div class="filter-sidebar-actions">
          <button class="btn btn-outline-secondary mr-2" @click="clearFilters">Limpar</button>
          <button class="btn btn-primary" @click="listandoByFilter(); showFilterSidebar = false">Pesquisar</button>
        </div>
      </div>
    </b-sidebar>
  </Layout>
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Dancing+Script');

.sig3 {
  font-family: 'Dancing Script';
  font-size: 1.9em;
}

.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subTitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .table-responsive {
    overflow: visible;
  }

  .dropdown-menu {
    z-index: 2000;
  }
}

.receita-header-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.integration-loading-modal-body {
  padding: 32px 24px;
}

.torge-products-modal {
  max-width: 1400px;
}

.torge-products-modal .modal-content {
  display: flex;
  max-height: calc(100vh - 32px);
  min-height: 82vh;
  flex-direction: column;
}

.torge-products-modal .modal-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(82vh - 140px);
  overflow-x: hidden;
  overflow-y: auto;
}

.integration-loading-content {
  display: flex;
  max-width: 360px;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.integration-loading-text {
  margin-top: 12px;
  margin-bottom: 0;
  color: #334155;
  font-weight: 500;
  line-height: 1.4;
}

.torge-products-loading {
  display: flex;
  min-height: 180px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.torge-products-loading-text {
  margin-top: 12px;
  margin-bottom: 0;
  color: #334155;
  font-weight: 500;
}

.torge-products-section + .torge-products-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.torge-products-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.torge-products-section {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
}

.produtor-autocomplete {
  position: relative;
}

.produtor-autocomplete-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 3000;
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #d9e4ec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
}

.produtor-autocomplete-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  background: transparent;
  text-align: left;
  transition: background-color 0.15s ease;
}

.produtor-autocomplete-item:hover {
  background: #f1f8f6;
}

.produtor-autocomplete-name {
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
}

.produtor-autocomplete-meta {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.produtor-autocomplete-state {
  padding: 12px;
  color: #64748b;
  font-size: 13px;
}

.torge-table-wrapper {
  display: flex;
  min-height: 0;
  max-height: 62vh;
  flex: 1;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: auto;
  background: #f8fafc;
}

.torge-products-table {
  min-width: 100%;
  margin-bottom: 0;
  background: #fff;
}

.torge-products-table th {
  white-space: nowrap;
  font-size: 12px;
  text-transform: uppercase;
  color: #64748b;
  background: #f1f5f9;
}

.torge-products-table td {
  min-width: 180px;
  vertical-align: top;
}

.torge-table-head-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.torge-products-table .form-control,
.torge-products-table .vs__dropdown-toggle {
  min-height: 38px;
}

.torge-cell-title {
  font-weight: 600;
  color: #0f172a;
}

.torge-empty-state {
  padding: 10px 0;
}

.filter-sidebar {
  padding: 8px 6px 24px;
}

.filter-sidebar-subtitle {
  margin-bottom: 16px;
  color: #5f7380;
  font-size: 13px;
}

.filter-sidebar-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.receita-download-renderer {
  left: -10000px;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 1240px;
}

@media (max-width: 991px) {
  .bloco {
    padding: 22px;
  }

  .bloco .titulo {
    font-size: 24px;
  }

  .receita-header-actions {
    margin-top: 20px;
    justify-content: flex-start;
  }

  .receita-header-actions .btn {
    margin-bottom: 8px;
  }

  .torge-products-section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .torge-products-table td {
    min-width: 150px;
  }

  .torge-table-head-action {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
